<template>
  <el-menu
    active-text-color="var(--r_theme)"
    text-color="#fff"
    background-color="var(--theme)"
    :router="true"
    :default-active="$route.path"
    mode="horizontal"
  >
    <el-menu-item :index="item.to" v-for="(item ,index) in navtopList" :key="index">{{item.name}}</el-menu-item>
    <el-menu-item :index="hasLogin ? '/jiyun': '/login'" class="entrance">
      <span class="el-icon-unlock"></span>
      <span>{{ $t( !hasLogin?'signIn[0]':'signIn[1]' ) }}</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    const routes = ['/', '/eco', '/faqs','/hongkong','/price', '/contact-us']
    return {
      routes,
    }
  },
  computed: {
    ...mapGetters(['hasLogin']),
    navtopList() {
      return this.$t('navtop').map((e, i) =>
        Object.assign({
          name: e,
          to: this.routes[i],
        })
      )
    },
    active() {
      const activePath = this.navtopList.filter(
        (e) => e.to === this.$route.fullPath
      )
      if (activePath.length === 0) {
        return '' //可默认指定
      }
      //console.log(11,activePath)
      return activePath[0].to
    },
  },
  props: {
    isUnderLine: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.el-menu {
  // padding-bottom: 6px;
  ::v-deep .el-menu-item {
    &:hover {
      background-color: #497709 !important;
    }
    $h: 49px;
    height: $h;
    line-height: $h;
    border-bottom-width: 0 !important;
    &.entrance {
      float: right;
      color: var(--theme) !important;
      background-image: linear-gradient(-45deg, #f3d216 25%, #ff0);
      &:hover {
        background-color: none !important;
      }
    }
  }
}
</style>